import React from 'react'
import { withTranslation } from 'react-i18next'
import { Grid, useTheme } from '@mui/material'
import { Box } from '@mui/material'

const Configuration1 = props => {
  const { t } = props
  const theme = useTheme()
  return (
    <Grid container ml={2} spacing={2}>
      <Grid item sx={12} md={7} lg={7}>
        <Box
          container
          style={{
            backgroundColor: 'white',
            margin: '60px 0',
            borderRadius: 20,
            boxShadow: `0px 0px 38px ${theme.palette.common.blackShade}`,
            textAlign: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 1
          }}>
          <h4>{t('AvailableAfterPurchasing')}</h4>
        </Box>
      </Grid>
    </Grid>
  )
}

export default withTranslation()(Configuration1)
